import React, {useEffect, useState} from "react";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import Footer from "../../../components/footer";

const MonthlyMonitoring = (props) => {
    let history = useHistory();

    const _get_all_work_sheets = useSelector((state) => state.work_sheets_module._get_all_work_sheets);

    const [datas, setDatas] = useState([]);

    useEffect(() => {
        if (_get_all_work_sheets.data.datos) {
            let v = _get_all_work_sheets.data.datos.filter(x => x.activo === true);
            setDatas(v);
        }
    }, [_get_all_work_sheets]);

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Seguimiento mensual"
                            items={[{label: "Consulta de acividades", link: "/segumiento-mensual"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                <div className="row mt-1">
                                    <div className="mb-1 col-12">
                                        <div className="pl-1 pr-1 border_card">
                                            <p className="ml-1" style={{marginTop: 10, fontSize: 18, color: '#727E8C'}}>Consulta de actividades mensuales</p>
                                        </div>
                                    </div>
                                    {datas.length > 0 && (
                                        datas.map((item) => (
                                            <div className="col-md-6 col-12 mb-1">
                                                <div className="d-flex p-1 border_card" style={{cursor: 'pointer'}} onClick={() => {
                                                    history.push(`/seguimiento/${item.id}/${item.nombre}/0/''/0/''/0/0`);
                                                }}>
                                                    <div className="d-flex">
                                                        <div className="ml-1">
                                                            <strong className="texto_16">{item.nombre}</strong><br/>
                                                            <strong className="texto_14">Procesos: {item.procesos.length}</strong><br/>
                                                            <span className="texto_14">{item.tipo_usuario}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
};

export default MonthlyMonitoring;
